<div class="card">
    <h2>{{ 'exports.full-exports.header' | translate }}</h2>
    <div class="cardContent" [formGroup]="form">
        <div class="inputGroup">
            <label for="exportType">{{ 'exports.full-exports.selectChannel' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error
                    [parentForm]="form"
                    [controlPath]="'channelId'"
                    [controlLabel]="'exports.full-exports.selectChannel' | translate"
                />
                <select id="exportType" formControlName="channelId">
                    @for (channel of channels(); track channel.value) {
                        <option [value]="channel.value">{{ channel.label | translate }}</option>
                    }
                </select>
            </div>
        </div>
        <div class="inputGroup">
            <label for="selectFullExportType">{{ 'exports.full-exports.selectFullExportType.label' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error
                    [parentForm]="form"
                    [controlPath]="'exportType'"
                    [controlLabel]="'exports.full-exports.selectFullExportType.label' | translate"
                />
                <select id="selectFullExportType" formControlName="exportType">
                    @for (
                        exportType of exportTypes | exportTypesFilter: form.get('channelId')!.value : channels();
                        track exportType.value
                    ) {
                        <option [value]="exportType.value">{{ exportType.label | translate }}</option>
                    }
                </select>
            </div>
        </div>
        <div class="inputGroup">
            <label for="shijiIDs">{{ 'exports.full-exports.shijiIDs.label' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error
                    [parentForm]="form"
                    [controlPath]="'listingIds'"
                    [controlLabel]="'exports.full-exports.shijiIDs.label' | translate"
                />
                <textarea id="shijiIDs" formControlName="listingIds"></textarea>
            </div>
        </div>
    </div>
    <div class="buttonArea">
        <button class="button primary" (click)="runFullExport()">{{ 'exports.full-exports.runExport' | translate }}</button>
    </div>
</div>
